! function(t) {
	"use strict";
	t.fn.scrollToMe = function(n) {
		var a = {
			offset: 50,
			duration: 500,
			easing: "swing",
			callback: null
		};
		n && t.extend(a, n);
		var o = this.offset().top - parseInt(a.offset);
		t("html, body").animate({
			scrollTop: o
		}, parseInt(a.duration), a.easing, function() {
			"function" == typeof a.callback && a.callback.call(this)
		})
	}
}(jQuery);
